var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

import * as colors from '@cimpress/react-components/lib/colors';
import { CONSTANTS } from './constants';
import request from '../services/request';
import { get } from 'lodash';
import { getToken } from '../services/token';
import jwtDecode from 'jwt-decode';
export var isEmptyArray = function isEmptyArray(array) {
  return !(array && array.length);
};
export var capitalize = function capitalize(inputString) {
  if (!inputString) {
    return '';
  }

  var strings = inputString.toString().split(' ');
  return strings.map(function (string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }).join(' ');
};
export var getValues = function getValues(pivot) {
  return pivot.selectedValues || pivot.defaults || pivot.values;
};
export var currencyCodes = [{
  code: 'EU',
  symbol: 'EUR'
}, {
  code: 'US',
  symbol: 'USD'
}, {
  code: 'AU',
  symbol: 'AUD'
}, {
  code: 'IN',
  symbol: 'INR'
}, {
  code: 'BR',
  symbol: 'BRL'
}, {
  code: 'CA',
  symbol: 'CAD'
}, {
  code: 'CH',
  symbol: 'CHF'
}, {
  code: 'GB',
  symbol: 'GBP'
}, {
  code: 'TR',
  symbol: 'TRY'
}];
export var colorStyle = {
  error: colors.danger.base,
  warning: colors.warning.base,
  info: colors.info.darker
};
export var sort = function sort(values) {
  if (!isEmptyArray(values)) {
    var isNumber = !Number.isNaN(Number(values[0]));

    if (typeof values[0] === 'number' || isNumber) {
      values.sort(function (a, b) {
        return a - b;
      });
    } else {
      values.sort(function (a, b) {
        if (a > b) return 1;
        if (a < b) return -1;
        return 0;
      });
    }
  }
};
export var makeCancelable = function makeCancelable(promise) {
  var cancelled = false;
  var cancelablePromise = new Promise(function (resolve, reject) {
    promise.then( // eslint-disable-next-line prefer-promise-reject-errors
    function (val) {
      return cancelled ? reject({
        isCanceled: true
      }) : resolve(val);
    }, // eslint-disable-next-line prefer-promise-reject-errors
    function (error) {
      return cancelled ? reject({
        isCanceled: true
      }) : reject(error);
    });
  });
  return {
    promise: cancelablePromise,
    cancel: function cancel() {
      cancelled = true;
    }
  };
};
export var createPivotingHeaders = function createPivotingHeaders(prefix, selectedColumn) {
  var headers = [];

  if (selectedColumn) {
    selectedColumn.selectedValues.forEach(function (attributeValue) {
      var header = {};
      header.name = capitalize(attributeValue); // eslint-disable-next-line no-param-reassign

      attributeValue = attributeValue.toString().replace('.', '-');
      header.value = "" + prefix + attributeValue + "|";
      headers.push(header);
    });
  }

  return headers;
};
export var getPivots = function getPivots(_a) {
  var selectedRow = _a.selectedRow,
      selectedColumn = _a.selectedColumn;
  var pivots = [];

  if (selectedRow) {
    pivots.push(selectedRow);
  }

  if (selectedColumn) {
    pivots.push(selectedColumn);
  }

  return pivots;
};
export var createEmptyColumns = function createEmptyColumns(prefix, selectedColumn) {
  var values = getValues(selectedColumn);
  return values.map(function (value) {
    var _a;

    var key = "" + prefix + value + "|";
    return _a = {}, _a[key] = {
      price: '-'
    }, _a;
  });
};
export var addErrorInfoToResults = function addErrorInfoToResults(rowResults, pivots, errorInfo) {
  if (errorInfo && !errorInfo.isEmpty) {
    Object.entries(errorInfo).forEach(function (entry) {
      var _a = __read(entry, 2),
          key = _a[0],
          value = _a[1];

      var keys = key.split('|');
      var attributeMap = {};
      keys.forEach(function (item) {
        var _a = __read(item.split('!'), 2),
            attributeName = _a[0],
            attributeValue = _a[1];

        attributeMap[attributeName] = attributeValue;
      });
      var X = attributeMap[pivots[0].key];
      var Y = (pivots[1] ? attributeMap[pivots[1].key] : '') + "|" + (pivots[2] ? attributeMap[pivots[2].key] + "|" : '');

      if (!rowResults[X]) {
        // eslint-disable-next-line no-param-reassign
        rowResults[X] = {};
      } // eslint-disable-next-line no-param-reassign


      rowResults[X][Y] = value;
    });
  }
};
export var addRulesValidationErrorInfo = function addRulesValidationErrorInfo(rowData, skuData, sku, pivots, contracts, catalogPriceModels, sellers) {
  var resolvedAttributes = skuData[sku].resolvedAttributes;
  resolvedAttributes.forEach(function (entry) {
    var values = entry.values,
        key = entry.key;

    if (!rowData[key]) {
      rowData[key] = [];
    }

    values.forEach(function (value) {
      var state = value.state,
          validationErrors = value.validationErrors,
          columnKey = value.key;

      if (state === CONSTANTS.UNRESOLVABLE) {
        var errorType_1 = 'error';
        var errorMessage_1 = "Validation Errors : " + validationErrors.join(' ');
        var attributeValue_1 = columnKey && columnKey.split('|')[1];
        var pivotHeader_1 = attributeValue_1 ? attributeValue_1 + "|" : '|';
        var matches_1;

        if (columnKey) {
          if (rowData[key].length) {
            rowData[key].forEach(function (item) {
              matches_1 = Object.keys(item).forEach(function (rowKey) {
                return rowKey.indexOf(attributeValue_1) > 0;
              });
            });
          }
        }

        if (!columnKey && rowData[key].length) {
          rowData[key].forEach(function (row) {
            row.errorType = errorType_1;
            row.errorMessage = errorMessage_1;
          });
        } else if (matches_1) {
          rowData[key].forEach(function (item) {
            Object.entries(item).forEach(function (rowEntry) {
              var _a = __read(rowEntry, 1),
                  rowKey = _a[0];

              if (rowKey.indexOf(attributeValue_1) > 0) {
                rowEntry[1] = __assign({
                  errorType: errorType_1,
                  errorMessage: errorMessage_1
                }, value);
              }
            });
          });
        } else {
          catalogPriceModels.forEach(function (priceModel) {
            var _a;

            var sellerId = priceModel.seller.sellerId,
                buyerId = priceModel.buyer.buyerId;
            var sellerName = sellers[sku][sellerId].sellerName;
            rowData[key].push((_a = {}, _a[sku + "|" + buyerId + "|" + sellerName + "|" + pivotHeader_1] = {
              errorType: errorType_1,
              errorMessage: errorMessage_1
            }, _a));
          });
          contracts.forEach(function (contract) {
            var _a;

            var sellerId = contract.seller.sellerId,
                buyerId = contract.buyer.buyerId;
            var sellerName = sellers[sku][sellerId].sellerName;
            rowData[key].push((_a = {}, _a[sku + "|" + CONSTANTS.CONTRACTS + "|" + sellerName + "-" + buyerId + "|" + pivotHeader_1] = {
              errorType: errorType_1,
              errorMessage: errorMessage_1
            }, _a));
          });
        }
      }
    });
  });
};
export var createEmptyRows = function createEmptyRows(_a) {
  var _b;

  var mcpSku = _a.mcpSku,
      contracts = _a.contracts,
      fulfillerId = _a.fulfillerId,
      errorInfo = _a.errorInfo,
      getState = _a.getState;
  var skuData = getState().pricingGrid.skuData;
  var _c = skuData[mcpSku],
      selectedRow = _c.selectedRow,
      selectedColumn = _c.selectedColumn;
  var rowResults = {};
  var emptyResults = {};

  if (selectedRow && selectedColumn) {
    var values = getValues(selectedRow);
    values.forEach(function (value) {
      rowResults[value] = {};
      var results = createEmptyColumns('', selectedColumn);
      results.forEach(function (result) {
        Object.keys(result).forEach(function (key) {
          rowResults[value][key] = result[key];
        });
      });
    });
  }

  var pivots = getPivots({
    selectedRow: selectedRow
  });
  addErrorInfoToResults(rowResults, pivots, errorInfo);
  contracts.forEach(function (contract) {
    if (contract && contract.seller && contract.seller.sellerId === fulfillerId && contract.buyer && contract.buyer.buyerId) {
      emptyResults[contract.buyer.buyerId] = rowResults;
    }
  });
  return _b = {}, _b[mcpSku] = emptyResults, _b;
};
export var getRowData = function getRowData(results, selectedRow) {
  if (!results) return null;
  var rowData = {};

  if (selectedRow) {
    var key_1 = capitalize(selectedRow.key);
    var values = getValues(selectedRow);
    values.forEach(function (value) {
      rowData[value] = {};
      rowData[value][key_1] = value;
    });
  } else {
    rowData['|'] = {};
  }

  results.forEach(function (result) {
    if (result) {
      Object.keys(result).forEach(function (sku) {
        Object.keys(result[sku]).forEach(function (buyerId) {
          Object.keys(result[sku][buyerId]).forEach(function (rowValue) {
            Object.keys(result[sku][buyerId][rowValue]).forEach(function (id) {
              var modifiedId = id.toString().replace('.', '-');

              if (selectedRow) {
                var combinedId = sku + "|" + buyerId + "|" + modifiedId;
                rowData[rowValue][combinedId] = result[sku][buyerId][rowValue][id];
              } else {
                var combinedId = sku + "|" + buyerId + "|" + rowValue + modifiedId;
                rowData['|'][combinedId] = result[sku][buyerId][rowValue][id];
              }
            });
          });
        });
      });
    }
  });
  rowData = Object.keys(rowData).sort(function (a, b) {
    return a - b;
  }).map(function (item) {
    return rowData[item];
  });
  return rowData;
};
export var countDecimals = function countDecimals(num) {
  if (num && Math.floor(num) !== num) return num.toString().split('.')[1].length || 0;
  return 0;
};
export var validateInputForAttribute = function validateInputForAttribute(value, quantityAttribute) {
  if (quantityAttribute) {
    if (quantityAttribute.isRange) {
      var _a = quantityAttribute.values,
          ranges = _a.ranges,
          fixedValues = _a.fixedValues;
      var isFixedValue = fixedValues ? fixedValues.indexOf(value) > -1 : false;
      var isWithinRange = false;

      for (var i = 0; i < ranges.length; i += 1) {
        var _b = ranges[i],
            minimum = _b.minimum,
            increment = _b.increment;
        var maximum = ranges[i].maximum;
        maximum = maximum === 'infinity' ? Number.MAX_SAFE_INTEGER : maximum;
        var incrementDecimalCount = countDecimals(increment);
        var multiplier = Math.pow(10, incrementDecimalCount);

        if (value >= minimum && value <= maximum) {
          var remainder = (value * multiplier - minimum * multiplier) / increment * multiplier;
          isWithinRange = Math.round(remainder) - remainder === 0;
        }

        if (isWithinRange) {
          break;
        }
      }

      return isFixedValue || isWithinRange;
    }

    return quantityAttribute.values && quantityAttribute.values.includes(value);
  }

  return null;
};
export var getCombinedErrorMessage = function getCombinedErrorMessage(errorMessage, shippingErrorMessage) {
  if (errorMessage && shippingErrorMessage) {
    return errorMessage + " " + shippingErrorMessage;
  }

  return errorMessage || shippingErrorMessage;
};
export var disableGridCell = function disableGridCell(priceCell) {
  return !!(priceCell && (priceCell.errorMessage || priceCell.shippingErrorMessage));
};
export var getErrorMessageAndColor = function getErrorMessageAndColor(header) {
  if (header && typeof header === 'object') {
    var errorMessage = header.errorMessage,
        errorType = header.errorType,
        shippingErrorMessage = header.shippingErrorMessage,
        shippingErrorType = header.shippingErrorType;
    var message = getCombinedErrorMessage(errorMessage, shippingErrorMessage);
    var color = errorType || shippingErrorType || 'info';
    return [message, color];
  }

  return [null, null];
};
export var getAttributeSelections = function getAttributeSelections(selectedAttributeValues, possibilitySet) {
  var selections = {};
  Object.keys(selectedAttributeValues).forEach(function (attribute) {
    if (selectedAttributeValues[attribute].length > 0) {
      selections[attribute] = selectedAttributeValues[attribute];
    } else {
      selections[attribute] = get(possibilitySet, attribute + ".possibleValues", []);
    }
  });
  return selections;
};
export function buildHeaders(headers) {
  if (headers === void 0) {
    headers = null;
  }

  return __assign({
    Accept: 'application/json'
  }, headers);
}
export var createHeadersWithoutDropdown = function createHeadersWithoutDropdown(selectedRow, selectedColumn, sku, sellers, contracts, catalogPriceModels, manufacturingCostModels, showCompetitivePricing, productPriceContractsInfo, skuSellerId, merchants, pricingVersion, priceConfigurations, accountMap) {
  var headerList = [];
  var pinned;

  if (selectedRow) {
    var key = capitalize(selectedRow.key);
    pinned = {
      name: key,
      value: key
    };
  }

  if (productPriceContractsInfo && productPriceContractsInfo.contracts) {
    productPriceContractsInfo.contracts.forEach(function (contract) {
      var title = contract.title,
          priceModelId = contract.priceModelId,
          revisionId = contract.revisionId,
          contractId = contract.contractId,
          effectiveStartDate = contract.effectiveStartDate,
          contractRevisionId = contract.contractRevisionId;
      var header = {
        name: title,
        value: title,
        isParent: false,
        info: {
          priceModelId: priceModelId,
          revisionId: revisionId,
          contractId: contractId,
          effectiveStartDate: effectiveStartDate,
          contractRevisionId: contractRevisionId
        }
      };
      headerList.push(header);
    });
  } else if (productPriceContractsInfo && productPriceContractsInfo.priceConfigurations) {
    productPriceContractsInfo.priceConfigurations.forEach(function (contract) {
      var title = contract.title;
      var header = {
        name: title,
        value: title,
        isParent: false
      };
      headerList.push(header);
    });
  } else if (pricingVersion === 'v1') {
    var prefix_1 = sku + "|" + CONSTANTS.CATALOG_PRICE + "|";
    var catalogPriceHeader_1 = {
      name: CONSTANTS.CATALOG_PRICE,
      value: prefix_1,
      isParent: true,
      children: []
    };
    var sellerMap_1 = sellers[sku];
    var buyerMap_1 = merchants[sku];

    if (catalogPriceModels && catalogPriceModels.length > 0) {
      catalogPriceModels.forEach(function (catalogPriceModel) {
        var sellerId = catalogPriceModel.seller.sellerId,
            priceModelId = catalogPriceModel.priceModelId,
            revisionId = catalogPriceModel.revisionId;
        var header = {};

        if (sellerMap_1 && sellerMap_1[sellerId]) {
          var sellerName = sellerMap_1[sellerId].sellerName;
          header.name = sellerName;
          header.value = "" + prefix_1 + sellerName + "|";
          header.info = {
            priceModelId: priceModelId,
            revisionId: revisionId
          };

          if (selectedColumn) {
            header.isParent = true;
            header.children = createPivotingHeaders(header.value, selectedColumn);
          } else {
            header.value += '|';
          }

          catalogPriceHeader_1.children.push(header);
        }
      });
    }

    if (catalogPriceHeader_1.children && catalogPriceHeader_1.children.length > 0) {
      headerList.push(catalogPriceHeader_1);
    }

    prefix_1 = sku + "|" + CONSTANTS.MANUFACTURING_COST + "|";
    var manufacturingCostHeader_1 = {
      name: CONSTANTS.MANUFACTURING_COST,
      value: prefix_1,
      isParent: true,
      children: []
    };

    if (manufacturingCostModels && manufacturingCostModels.length > 0) {
      manufacturingCostModels.forEach(function (manufacturingCostModel) {
        var sellerId = manufacturingCostModel.seller.sellerId,
            priceModelId = manufacturingCostModel.priceModelId,
            revisionId = manufacturingCostModel.revisionId;
        var header = {};

        if (sellerMap_1 && sellerMap_1[sellerId]) {
          var sellerName = sellerMap_1[sellerId].sellerName;
          header.name = sellerName;
          header.value = "" + prefix_1 + sellerName + "|";
          header.info = {
            priceModelId: priceModelId,
            revisionId: revisionId
          };

          if (selectedColumn) {
            header.isParent = true;
            header.children = createPivotingHeaders(header.value, selectedColumn);
          } else {
            header.value += '|';
          }

          manufacturingCostHeader_1.children.push(header);
        }
      });
    }

    if (manufacturingCostHeader_1.children && manufacturingCostHeader_1.children.length > 0) {
      headerList.push(manufacturingCostHeader_1);
    }

    prefix_1 = sku + "|" + CONSTANTS.CONTRACTS + "|";
    var contractsHeader_1 = {
      name: CONSTANTS.CONTRACTS,
      value: prefix_1,
      isParent: true,
      children: []
    };
    var networkPrefix = sku + "|" + CONSTANTS.NETWORK + "|";
    var networkHeader_1 = {
      name: CONSTANTS.NETWORK,
      value: networkPrefix,
      isParent: true,
      children: []
    };

    if (contracts && contracts.length > 0) {
      contracts.forEach(function (contract) {
        var buyerId = contract.buyer.buyerId,
            sellerId = contract.seller.sellerId,
            priceModelId = contract.priceModelId,
            revisionId = contract.revisionId,
            contractId = contract.contractId,
            effectiveStartDate = contract.effectiveStartDate,
            contractRevisionId = contract.contractRevisionId;

        if (sellerMap_1 && sellerMap_1[sellerId] && buyerMap_1 && buyerMap_1[buyerId]) {
          var sellerName = sellerMap_1[sellerId].sellerName;
          var skuSellerAccountId = (sellerMap_1[skuSellerId] || {
            accountId: null
          }).accountId;
          var buyerAccountId = buyerMap_1[buyerId].accountId;
          var header = {
            value: "" + prefix_1 + sellerName + "-" + buyerId + "|"
          };
          header.info = {
            priceModelId: priceModelId,
            revisionId: revisionId,
            contractId: contractId,
            effectiveStartDate: effectiveStartDate,
            contractRevisionId: contractRevisionId
          };

          if (selectedColumn) {
            header.isParent = true;
            header.children = createPivotingHeaders(header.value, selectedColumn);
          } else {
            header.value += '|';
          } // Ignore contracts where sellerId is different from skuSellerId


          if (sellerId === skuSellerId) {
            header.name = "" + capitalize(buyerId);
            contractsHeader_1.children.push(header);
          } else if (skuSellerAccountId === buyerAccountId) {
            header.name = "" + sellerName;
            networkHeader_1.children.push(header);
          }
        }
      });
    }

    if (contractsHeader_1.children && contractsHeader_1.children.length > 0) {
      headerList.push(contractsHeader_1);
    }

    if (networkHeader_1.children && networkHeader_1.children.length > 0) {
      headerList.push(networkHeader_1);
    }
  } else if (pricingVersion === 'v2') {
    var headerMap = createHeaderMapV2(sku, priceConfigurations, accountMap, selectedColumn);

    if (headerMap['Catalog Price']) {
      headerList.push(headerMap['Catalog Price']);
    }

    if (headerMap['Manufacturing Cost']) {
      headerList.push(headerMap['Manufacturing Cost']);
    }

    if (headerMap.Contracts) {
      headerList.push(headerMap.Contracts);
    }
  }

  return showCompetitivePricing ? headerList : {
    pinned: pinned,
    headerList: headerList
  };
};

var createTopHeader = function createTopHeader(sku, name) {
  return {
    name: name,
    value: sku + "|" + name + "|",
    isParent: true,
    children: []
  };
};

var createChildHeader = function createChildHeader(sku, headerName, name, selectedColumn) {
  var header = {
    name: name,
    value: sku + "|" + headerName + "|" + name + "|"
  };

  if (selectedColumn) {
    header.isParent = true;
    header.children = createPivotingHeaders(header.value, selectedColumn);
  } else {
    header.value += '|';
  }

  return header;
};

var createHeader = function createHeader(headerMap, sku, type, sellerName, name, selectedColumn) {
  if (!headerMap[type]) {
    headerMap[type] = createTopHeader(sku, type);
  }

  var headerName = type === CONSTANTS.CONTRACTS ? name : sellerName;
  var header = createChildHeader(sku, type, headerName, selectedColumn);
  headerMap[type].children.push(header);
};

var createHeaderMapV2 = function createHeaderMapV2(sku, priceConfigurations, accountMap, selectedColumn) {
  var headerMap = {};
  var mapping = {
    catalogPrice: CONSTANTS.CATALOG_PRICE,
    manufacturingCost: CONSTANTS.MANUFACTURING_COST,
    transferPrice: CONSTANTS.CONTRACTS
  };
  priceConfigurations.forEach(function (configuration) {
    var buyer = configuration.buyer,
        seller = configuration.seller,
        priceType = configuration.priceType;
    var sellerName = seller && accountMap[seller].name;
    var buyerName = buyer && accountMap[buyer].name;
    var name = sellerName + "-" + buyerName;
    createHeader(headerMap, sku, mapping[priceType], sellerName, name, selectedColumn);
  });
  return headerMap;
};

export var getFiscalYear = function getFiscalYear() {
  var currentTime = new Date();
  var month = currentTime.getMonth();
  var fiscalYear = currentTime.getFullYear();

  if (month > 5) {
    fiscalYear++;
  }

  return fiscalYear.toString();
};
export var createHeadersPerSku = function createHeadersPerSku(selectedRow, selectedColumn, sku, contractsPerSku, catalogPriceModelsPerSku, manufacturingCostModelsPerSku, sellers, showCompetitivePricing, productPriceContractsInfo, skuSellerId, merchants, pricingVersion, priceConfigurations, accountMap) {
  var headerList = createHeadersWithoutDropdown(selectedRow, selectedColumn, sku, sellers, contractsPerSku[sku], catalogPriceModelsPerSku[sku], manufacturingCostModelsPerSku[sku], showCompetitivePricing, productPriceContractsInfo, skuSellerId, merchants, pricingVersion, priceConfigurations, accountMap);

  if (pricingVersion === 'v1' && (!catalogPriceModelsPerSku[sku] || !catalogPriceModelsPerSku[sku].length) && (!contractsPerSku[sku] || !contractsPerSku[sku].length) && (!manufacturingCostModelsPerSku[sku] || !manufacturingCostModelsPerSku[sku].length) || pricingVersion === 'v2' && (!priceConfigurations || priceConfigurations.length === 0)) {
    var catalogHeader = {
      name: CONSTANTS.CATALOG_PRICE,
      value: sku + "|" + CONSTANTS.CATALOG_PRICE + "|",
      errorType: 'error',
      errorMessage: CONSTANTS.NO_PRICE_MESSAGE
    };
    headerList.headerList.unshift(catalogHeader);
  }

  return headerList;
};
export var getFilterSettingsUser = function getFilterSettingsUser() {
  return getCustomSettings('PRICEEXPLORER_FILTER_CONFIG').then(function (result) {
    return result && result.configuration;
  });
};
export var setFilterSettingsUser = function setFilterSettingsUser(configuration) {
  return setCustomSettings('PRICEEXPLORER_FILTER_CONFIG', {
    configuration: configuration
  });
};
export var getGridSettingsUser = function getGridSettingsUser() {
  return getCustomSettings('PRICEEXPLORER_PRICE_SETTINGS_CONFIG').then(function (result) {
    return result && result.configuration;
  });
};
export var setGridSettingsUser = function setGridSettingsUser(configuration) {
  return setCustomSettings('PRICEEXPLORER_PRICE_SETTINGS_CONFIG', {
    configuration: configuration
  });
};
export var getCustomSettings = function getCustomSettings(resourceId) {
  return request("https://customizr.at.cimpress.io/v1/resources/" + resourceId + "/settings");
};
export var setCustomSettings = function setCustomSettings(resourceId, settings) {
  return request("https://customizr.at.cimpress.io/v1/resources/" + resourceId + "/settings", 'PUT', JSON.stringify(settings));
};
export var getTabConfiguration = function getTabConfiguration() {
  return getCustomSettings('PRICING_GRID_TAB_CONFIG').then(function (result) {
    return result && result.selectedTab;
  }).catch(function () {
    return 0;
  });
};
export var setTabConfiguration = function setTabConfiguration(selectedTab) {
  return setCustomSettings('PRICING_GRID_TAB_CONFIG', {
    selectedTab: selectedTab
  });
};
export var getTabIndexFromKey = function getTabIndexFromKey(key) {
  if (!key) {
    return 0;
  }

  switch (key) {
    case 'grossMargin':
      return 2;

    case 'cost':
      return 1;

    case 'price':
    default:
      return 0;
  }
};
export var getKeyFromTabIndex = function getKeyFromTabIndex(index) {
  switch (index) {
    case 2:
      return 'grossMargin';

    case 1:
      return 'cost';

    case 0:
    default:
      return 'price';
  }
};

var getEmail = function getEmail(decodedJWT) {
  return decodedJWT['https://claims.cimpress.io/email'];
};

export var getUserEmail = function getUserEmail() {
  var token = getToken();

  if (token) {
    var decodedJWT = jwtDecode(token);
    return getEmail(decodedJWT);
  }

  return null;
};